import Figure from "~/components/figure"
import Circuit from "~/components/circuit"

export default class Pathways3 extends Component {
  render() {
    return (
      <Surface gridColumn="screen" alignItems="center">
        <Surface
          justifyContent="space-between"
          alignSelf="center"
          flexFlow="row"
        >
          <Circuit
            circuitProps={{
              moduleWidth: "auto",
              moduleMarginX: 100,
              firstActiveNeurons: [`mixed4b:429`],
            }}
            inlineLayerNames
            circuit={[
              {
                name: "mixed4a",
                modules: [
                  {
                    name: "Center",
                    neurons: [268, 201],
                  },
                  {
                    name: "Eyes",
                    neurons: [501, 489],
                  },
                  {
                    name: "Left",
                    neurons: [325, 222],
                  },
                  {
                    name: "Boundary",
                    neurons: [290],
                  },
                ],
              },
              {
                name: "mixed4b",
                modules: [
                  {
                    name: "Left",
                    neurons: [429],
                  },
                ],
              },
            ]}
          />
        </Surface>
      </Surface>
    )
  }
}
